import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

declare module "@mui/material/styles" {
  interface ButtonVariants {
    "page-header": React.CSSProperties;
  }

  interface ButtonVariantsOptions {
    "page-header"?: React.CSSProperties;
  }
}

// Augment Button variants to include custom "page-header" variant
declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    "page-header": true;
  }
}

export function getMuiButton(_theme: Theme): MuiThemeComponentOverride<"MuiButton"> {
  return {
    MuiButton: {
      defaultProps: {
        color: "primary",
        variant: "contained",
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          variants: [
            {
              props: { variant: "page-header" },
              style: {
                "&:hover": {
                  backgroundColor: "#106B8F", // Color.BLUE[300].dark
                },

                // xs: 0.5 * 8px = 4px = 0.25rem
                "@media (min-width: 576px)": {
                  // sm breakpoint
                  fontSize: "0.8125rem",
                  paddingBottom: "0.375rem",
                  paddingLeft: "1rem", // sm: 2 * 8px = 16px = 1rem
                  paddingRight: "1rem",
                  paddingTop: "0.375rem", // sm: 0.75 * 8px = 6px = 0.375rem
                },

                "@media (min-width: 768px)": {
                  // md breakpoint
                  fontSize: "0.875rem",
                  paddingBottom: "0.5rem",
                  paddingTop: "0.5rem", // md: 1 * 8px = 8px = 0.5rem
                },

                backgroundColor: "#1380AA",

                // Color.BLUE[300].main - primary color
                color: "#FFFFFF",

                // white text
                fontSize: "0.75rem",

                // xs breakpoint
                paddingBottom: "0.25rem",

                paddingLeft: "0.5rem",
                // xs: 1 * 8px = 8px = 0.5rem
                paddingRight: "0.5rem",
                paddingTop: "0.25rem",
              },
            },
          ],
        },
      },
    },
  };
}
